import { render } from "./AppSidebar.vue?vue&type=template&id=769c45e7&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=769c45e7&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=1&id=769c45e7&lang=scss&scoped=true"
import "./AppSidebar.vue?vue&type=style&index=2&id=769c45e7&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769c45e7"]])

export default __exports__